import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { makeSelectShelvesSelected } from 'containers/Configurator/selectors/selection';

const selectDrawersPanelDomain = (state: ApplicationRootState) =>
  state.drawersCompositionPanel || initialState;

export const makeSelectIsVisibleDrawersCompositionPanel = () =>
  createSelector(
    selectDrawersPanelDomain,
    substate => substate.isVisible,
  );

export const makeSelectDrawerSelectedNumber = () =>
  createSelector(
    makeSelectShelvesSelected(),
    (shelvesSelected): number | undefined => {
      let numberDrawer = undefined;
      for (let shelf of shelvesSelected) {
        if (!numberDrawer) numberDrawer = shelf.drawers.length;
        else if (numberDrawer !== shelf.drawers.length) {
          return undefined;
        }
      }
      return numberDrawer;
    },
  );

export { selectDrawersPanelDomain };
